import React, { useState } from "react";
import {
  TextInput,
  Button,
  Container,
  Grid,
  Select,
  LoadingOverlay,
  Menu,
  Modal,
  Notification,
} from "@mantine/core";
import { useForm } from "@mantine/form";
import { FontIcon } from "react-md";
import SearchDropdown from "react-select";
import { DatePicker, DateRangePicker } from "@mantine/dates";
import LabtestService from "../services/LabtestService";
import "../style/dashboard.css";
import { showNotification } from "@mantine/notifications";
import StorageService from "../services/StorageService";
import { IconLogout, IconCheck, IconX } from "@tabler/icons";
import { useNavigate } from "react-router-dom";
import profileMale from "../assets/male.png";
import { useEffect } from "react";
import NavigoService from "../services/NavigoService";
import dayjs from "dayjs";
import AddressService from "../services/AddressService";
import { Row, Col } from "react-flexbox-grid";
import { TextField } from "@material-ui/core";
import Autocomplete from "@material-ui/lab/Autocomplete";
import Dialog from "@material-ui/core/Dialog";

const labtestService = new LabtestService();
const storageService = new StorageService();

const TimeslotToString = (slot: number): string => {
  let h = Math.floor(slot / 60);
  let hStr = h < 10 ? `0${h.toString()}` : h;
  let m = slot % 60;
  let mStr = m < 10 ? `0${m.toString()}` : m;
  return `${hStr}:${mStr}`;
};

const convertTimeToMinutes = (timeString: any) => {
  const [hours, minutes] = timeString.split(":").map(Number);

  // Calculate total minutes
  const totalMinutes = hours * 60 + minutes;

  return totalMinutes;
};

export const NotificationStyles = {
  position: "fixed",
  left: "0",
  bottom: "40px",
  width: "100%",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  zIndex: 9999,
} as React.CSSProperties;

function Dashboard() {
  const [searchStatus, setSearchStatus] = React.useState<string>("1");
  let [countryCode, setCountryCode] = React.useState<string>("91");

  const [searchString, setSearchString] = React.useState<string>("");
  const [services, setServices] = React.useState<any>([]);

  const [selectedService, setSelectedService] = React.useState<number>();
  const [newSelectedService, setNewSelectedService] = React.useState<number>();
  const [newPincode, setNewPincode] = React.useState<any>();
  const [newAid, setNewAid] = React.useState<any>();
  const [newAddressId, setNewAddressId] = React.useState<any>();
  const [newEmail, setNewEmail] = React.useState<string>();
  const [newVendorId, setNewVendorId] = React.useState<any>();
  const [patientId, setPatientID] = React.useState<any>();
  const [slots, setSlots] = React.useState<any>([]);
  const [newSlots, setNewSlots] = React.useState<any>([]);
  const [timeSlotId, setTimeSlotId] = React.useState<number>();
  const [newTimeSlotId, setNewTimeSlotId] = React.useState<number>();
  const [date, setDate] = React.useState<Date>();
  const [newDate, setNewDate] = React.useState<Date>();
  const [selectedSlot, setSelectedSlot] = React.useState<string>();
  const [newSelectedSlot, setNewSelectedSlot] = React.useState<any>();
  const [emails, setEmails] = React.useState<any>(null);
  const [selectedEmail, setSelectedEmail] = React.useState<string>();
  const [isAddress, setIsAddress] = React.useState<boolean>();
  const [addresses, setAddresses] = React.useState<any>([]);
  const [selectedAddress, setSelectedAddress] = React.useState<String>("");
  const [selectedAddressId, setSelectedAddressId] = React.useState<any>();
  const [newSelectedAddressId, setNewSelectedAddressId] = React.useState<any>();
  const [isOpenAddAddress, setIsOpenAddAddress] =
    React.useState<boolean>(false);
  const [openLabtest, setLabtestOpen] = React.useState<boolean>(false);
  const [pastModal, setPastModal] = React.useState<boolean>(false);
  const [nextModal, setNextModal] = React.useState<boolean>(false);
  const [openEditModal, setOpenEditModal] = React.useState<boolean>(false);
  const [selectedAppointment, setSelectedAppointment] =
    React.useState<any>(null);
  const [error, setError] = React.useState("");
  const [appointmentSuccess, setAppointmentSuccess] = React.useState(false);
  const [vendorId, setVendorId] = React.useState<string>();
  const checkAuthSorage = () => {
    let result = false;
    let tok = storageService.get("token");
    if (tok === null) {
      result = true;
    }
    return result;
  };
  const [loading, setLoading] = React.useState<boolean>(checkAuthSorage());

  const [minDay, setMinDay] = React.useState<number>();
  const [maxDay, setMaxDay] = React.useState<number>();

  const [labInvestigation, setLabInvestigation] = React.useState<object>({});

  const [dataTables, setDataTables] = React.useState<object>({});

  const [logOut, setLogout] = React.useState<boolean>(false);
  const [appointList, setAppointList] = React.useState<any>([]);
  const [noAppointment, setNoAppointment] = React.useState(true);
  const [totalCount, setTotalCount] = React.useState(0);
  const [searchlist, setSearchlist] = React.useState("");
  const [listStatus, setListStatus] = React.useState(4);
  const skip = React.useRef(30);
  const [menuFor, setMenuFor] = React.useState({});
  const [currentAppointment, setCurrentAppointment] = React.useState({});
  const [patientAddress, setPatientAddress] = React.useState<any>("");
  const [addressFound, setAddressFound] = React.useState<boolean>(false);
  const [newAddress, setNewAddress] = React.useState<boolean>(false);
  const [serviceEmail, setServiceEmail] = React.useState<{ email: string }[]>(
    [],
  );
  const [reloadPage, setReloadPage] = React.useState<boolean>(false);

  let [district, setDistrict] = React.useState<string>("");
  let [pincode, setPincode] = React.useState<string>("");
  let [state, setState] = React.useState<string>("");
  let [city, setCity] = React.useState<string>("");
  let [line1, setLine1] = React.useState<string>("");
  let [line2, setLine2] = React.useState<string>("");
  let [landmark, setLandmark] = React.useState<string>("");
  let [type, setType] = React.useState<string>("");
  let [name, setName] = React.useState<string>("");
  let [phoneNo, setPhoneNo] = React.useState<string>("");
  // let [countryCodeAddress, setCountryCodeAddress] = React.useState<number>();
  let addressTypes = ["Home", "Work", "Other"];
  let countryCodeOptions = ["91", "1", "971"];
  let [errorFlag, setErrorFlag] = React.useState<boolean>(false);

  let ns = new NavigoService();
  let as = new AddressService();
  interface ServiceOption {
    value: number;
    label: string;
    maxDay: string;
    minDay: string;
    // Add other properties if needed
  }

  interface Address {
    id: number;
    formattedAddress: string;
    pincode: number;
  }

  const customStyles = {
    // ... other styles
    placeholder: (provided: any) => ({
      ...provided,
      fontSize: "14px",
      color: "#cccccc", // Change the color of the placeholder text
    }),
  };

  useEffect(() => {
    let emails = services?.response?.filter(
      (s: any) => s.value == selectedService,
    );
    if (emails?.length > 0) {
      setEmails(emails[0]?.emails);
      // console.log("emails",emails[0]?.emails)
    }
    if (selectedService !== undefined) {
      ns.getServiceById(
        selectedService,
        (result: any) => {
          // console.log("selected service data is", result.addressRequired)
          setIsAddress(result.addressRequired);
        },
        () => {},
      );
    }
  }, [selectedService]);

  const getAddresses = () => {
    as.getPatientAddress(
      parseInt(searchString),
      (result: any) => {
        // console.log("result is",result)
        const addressArray = result.map((address: any) => ({
          // return (
          id: address.id,
          formattedAddress: `${address.line1}, ${address.line2}, ${address.landmark}, ${address.district}, ${address.city}, ${address.state} - ${address.pincode} - Phone No - ${address.phoneNo}`,
          pincode: address.pincode,
          // )
        }));
        // console.log("address array", addressArray)
        setAddresses(addressArray);
      },
      (error: any) => {
        console.log("error is", error);
      },
    );
  };

  const openAddAddress = () => {
    setIsOpenAddAddress(true);
    // console.log(isOpenAddAddress)
  };

  const changeFields = (value: any, name: any) => {
    switch (name) {
      case "district":
        setDistrict(value);
        break;
      case "type":
        setType(value);
        break;
      case "pincode":
        setPincode(value);
        break;
      case "state":
        setState(value);
        break;
      case "city":
        setCity(value);
        break;
      case "line1":
        setLine1(value);
        break;
      case "line2":
        setLine2(value);
        break;
      case "landmark":
        setLandmark(value);
        break;
      case "name":
        setName(value);
        break;
      case "phone":
        if (value.length <= 10) setPhoneNo(value);
        break;
      case "cc":
        setCountryCode(value);
        break;
    }
  };

  const submit = () => {
    let addressBody = {
      city: city,
      countryCode: parseInt(countryCode),
      district: district,
      landmark: landmark,
      line1: line1,
      line2: line2,
      name: name,
      patientId: parseInt(searchString),
      phoneNo: parseInt(phoneNo),
      pincode: parseInt(pincode),
      state: state,
      type: type,
    };
    as.addPatientAddress(
      addressBody,
      (result: any) => {
        console.log(result);
      },
      (error: any) => {
        console.log(error);
      },
    );
  };

  const handleCreate = () => {
    if (selectedService && date && selectedService) {
      setLoading(true);
      const index =
        selectedSlot !== null
          ? slots.findIndex((slot: any) => slot.value === selectedSlot)
          : -1;
      const selectedTime =
        index !== -1 && slots[index].label ? slots[index].label : null;
      const selectedTimeString = selectedTime as string;
      let appointment = {
        patientID: parseInt(searchString),
        bookedFor: 0,
        serviceID: selectedService,
        status: 0,
        bookingDate: dayjs().toISOString(),
        appointmentDate: dayjs(date)
          .add(5, "hours")
          .add(30, "minutes")
          .toISOString(),
        timeSlot: parseInt(convertTimeToMinutes(selectedTimeString)),
        timeSlotId: timeSlotId,
        email: selectedEmail,
        // address: selectedAddress,
        addressId: selectedAddressId,
        vendorId: vendorId,
      };

      ns.createAppointment(
        appointment,
        (d: any) => {
          setLoading(false);
          setError("");
          setSearchString("");
          setAppointmentSuccess(true);
          setDate(undefined);
          setSelectedSlot(undefined);
          setSelectedService(undefined);
          setNextModal(false);
          setSelectedAddress("");
          setSelectedAddressId(undefined);
        },
        (e: any) => {
          if ("message" in e) {
            setLoading(false);
            setError(e?.message);
          } else {
            setError(JSON.stringify(e));
          }
        },
      );
    }
  };

  useEffect(() => {
    let ns = new NavigoService();
    setLoading(true);
    ns.getServices(
      (d: any) => {
        setLoading(false);
        setServices(d);
        console.log("services data", d);
      },
      () => {},
    );
  }, []);

  useEffect(() => {
    if (serviceEmail.length > 0) {
      setSelectedEmail(serviceEmail[0].email);
    }
  }, [serviceEmail]);

  useEffect(() => {
    setSlots([]);
    setNewSlots([]);
    setTimeSlotId(undefined);
    setNewTimeSlotId(undefined);
    setSelectedSlot(undefined);
    setNewSelectedSlot(undefined);
    if (date) {
      let ns = new NavigoService();
      setLoading(true);
      ns.getSlots(
        parseInt(searchString),
        selectedService,
        dayjs(date).format("YYYY-MM-DD"),
        // parseInt(pincode),
        pincode,
        selectedAddressId,
        selectedEmail,
        "",
        (d: any) => {
          setLoading(false);
          // console.log("slots response is: ", d);
          let slots: any = [];
          // d.slot = d?.slot.sort((a: any, b: any) => a - b);
          d.slots = d?.slots.sort((a: any, b: any) => a.value - b.value);
          // d?.slots.map((s: number) => {
          //   slots.push({ value: s.toString(), label: TimeslotToString(2s) });
          // });
          d?.slots.map((timeSlot: any) => {
            slots.push({
              value: timeSlot.key.toString(),
              label: TimeslotToString(timeSlot.value),
            });
          });
          // console.log(d.slots);
          // console.log(slots);
          setSlots(slots);
          setVendorId(d.vendorId);
        },
        () => {},
      );
    } else if (newDate) {
      let ns = new NavigoService();
      setLoading(true);
      ns.getSlots(
        parseInt(patientId),
        newSelectedService,
        dayjs(newDate).format("YYYY-MM-DD"),
        newPincode,
        newAid,
        selectedEmail,
        "",
        (d: any) => {
          setLoading(false);
          // console.log("slots response is: ", d);
          let Newslots: any = [];
          // d.slot = d?.slot.sort((a: any, b: any) => a - b);
          d.slots = d?.slots.sort((a: any, b: any) => a.value - b.value);
          // d?.slots.map((s: number) => {
          //   slots.push({ value: s.toString(), label: TimeslotToString(2s) });
          // });
          d?.slots.map((timeSlot: any) => {
            slots.push({
              value: timeSlot.key.toString(),
              label: TimeslotToString(timeSlot.value),
            });
          });
          // console.log(d.slots);
          // console.log(slots);
          setNewSlots(slots);
          setNewVendorId(d.vendorId);
        },
        () => {},
      );
    }
  }, [date, newDate]);

  // useEffect(() => {
  //   if (selectedAppointment) {
  //     setPatientID(selectedAppointment.appointment.patientID);
  //     setNewSelectedService(selectedAppointment.service.ID);
  //     setNewPincode("160080");
  //     setNewAid(selectedAppointment.appointList.ID);
  //     setNewEmail(selectedAppointment.patient.email);
  //   }
  // }, [newDate]);

  useEffect(() => {
    if (logOut) {
      storageService.clearAll();
      window.location.reload();
      window.location.reload();
    }
  }, [logOut]);

  const searchPatient = () => {
    // getDataTables();
    // setTimeout(() => {
    //   setLabtestOpen(true);
    // }, 2000);
    let onResponse = (data: any) => {
      setTimeout(() => {
        setLoading(false);
        setLabtestOpen(true);
      });
    };
    let onError = () => {
      setLoading(false);
      showNotification({
        title: "No Patient found",
        message: "",
        color: "red",
      });
    };

    labtestService.searchPatient(
      searchStatus,
      searchString,
      onResponse,
      onError,
    );
  };

  useEffect(() => {
    if (searchlist === "") {
      skip.current = 30;
      handleGetAllAppointments(1, 0, listStatus, "");
    }
  }, [searchlist]);

  useEffect(() => {
    if (reloadPage) {
      skip.current = 30;
      handleGetAllAppointments(1, 0, listStatus, "");
    }
  }, [reloadPage]);

  const handleGetAllAppointments = (
    type = 1,
    btnType = 0,
    status = 4,
    clientCode = "",
    dateFlag = true,
  ) => {
    setLoading(true);
    let filter: { [key: string]: any } = {};
    let isFilter = false;
    let fromDate = "";
    let toDate = "";
    let serviceType = "";
    let cfromDate = "";
    let ctoDate = "";

    if (searchlist) {
      filter["appointments.patientID"] = [{ o: "=", v: searchlist }];
      isFilter = true;
    }

    labtestService.searchPastAppointments(
      30,
      skip.current - 30,
      (res: any) => {
        console.log("response is:", res);
        if (res && res.appointments.length > 0) {
          let allList = [];

          allList = res.appointments.map((appoint: any) => {
            return { ...appoint };
          });

          setAppointList([...allList]);
          setNoAppointment(false);
          setTotalCount(res.count);
          setLoading(false);
        } else {
          setAppointList([]);
          setNoAppointment(true);
          setLoading(false);
        }
      },
      (err: any) => {
        console.log("not able to fetch data");
      },
      status,
      isFilter ? encodeURIComponent(JSON.stringify(filter)) : "",
      fromDate,
      toDate,
      serviceType,
      cfromDate,
      ctoDate,
    );
  };

  const rescheduleAppointment = () => {
    const index =
      newSelectedSlot !== null
        ? newSlots.findIndex((slot: any) => slot.value === newSelectedSlot)
        : -1;
    const selectedTime =
      index !== -1 && newSlots[index].label ? newSlots[index].label : null;
    const selectedNewTimeString = selectedTime as string;
    const payload = {
      appointmentID: selectedAppointment.appointment.ID,
      appointmentDate: newDate,
      email: selectedEmail,
      timeslot: parseInt(convertTimeToMinutes(selectedNewTimeString)),
      timeSlotId: newTimeSlotId,
      vendor: selectedAppointment.appointment.vendorId,
      vendorCode: selectedAppointment.appointment.vendorCode,
      // rescheduledBy:null
    };
    labtestService.reschedule(
      payload,
      (res: any) => {
        setLoading(false);
        setReloadPage(true);
        setNewDate(undefined);
        setNewSelectedSlot(undefined);
        setNewEmail(undefined);
        console.log("appointment rescheduled succesfully");
      },
      (e: any) => {
        setLoading(false);
        setError(JSON.stringify(e));
      },
    );
  };

  const getAddress = (id: any, aid: any) => {
    as.getPatientAddress(
      id,
      (result: any) => {
        if (Array.isArray(result) && result.length > 0) {
          const addressObject = result.find((item: any) => item.id == aid);
          if (addressObject) {
            const formattedAddress = `${addressObject.line1}, ${addressObject.line2}, ${addressObject.landmark}, ${addressObject.district}, ${addressObject.city}, ${addressObject.state} - ${addressObject.pincode} - Phone No - ${addressObject.phoneNo}`;
            setPatientAddress(formattedAddress);
            setNewPincode(addressObject.pincode);
            setNewAid(addressObject.id);
            setNewAddress(true);
          } else {
            setAddressFound(false);
            setNewAddress(false);
          }
        } else {
          setAddressFound(false);
          setNewAddress(false);
        }
      },
      (error: any) => {
        console.log("error is", error);
        setPatientAddress("Error fetching address");
      },
    );
  };

  const getServiceEmail = (id: any) => {
    ns.getServiceById(
      id,
      (result: any) => {
        if (Array.isArray(result.calendars)) {
          const emails = result.calendars.map((calendar: any) => ({
            email: calendar.email,
          }));
          setServiceEmail(emails);
          // Check if islabtest is true
          if (result.addressRequired) {
            setAddressFound(true);
          } else {
            setAddressFound(false);
          }
        } else {
          console.error("result.calendars is not an array:", result.calendars);
          setServiceEmail([]);
          setAddressFound(false);
        }
      },
      (err: any) => {
        console.error("no service found", err);
        setAddressFound(false);
      },
    );
  };

  const handleSelectChange = (val: any) => {
    // Find the index (timeSlotId) of the selected slot
    const selectedSlot =
      val !== null ? slots.find((slot: any) => slot.value === val) : -1;
    // const selectedSlot = val !== null ? slots.find((slot : any) => slot.value === val) : -1;
    // console.log("selectedSlot here is:", selectedSlot)
    // Update the selected selectedSlot state
    setTimeSlotId(selectedSlot ? parseInt(selectedSlot.value) : -1);
    setSelectedSlot(val);
  };

  const handleNewSelectChange = (val: any) => {
    // Find the index (timeSlotId) of the selected slot
    const newSelectedSlot =
      val !== null ? newSlots.find((slot: any) => slot.value === val) : -1;
    setNewTimeSlotId(newSelectedSlot ? parseInt(newSelectedSlot.value) : -1);
    setNewSelectedSlot(val);
  };

  const getPlaceholderText = () => {
    if (date === undefined || slots === undefined) {
      return "Choose a timeslot";
    } else if (slots.length > 0) {
      return "Choose a timeslot";
    } else {
      return "No slots available";
    }
  };
  const getNewPlaceholderText = () => {
    if (newDate === undefined || newSlots === undefined) {
      return "Choose a timeslot";
    } else if (newSlots.length > 0) {
      return "Choose a timeslot";
    } else {
      return "No slots available";
    }
  };

  const logoutBtn = () => {
    let phoneNo = storageService.get("phone_no");
    return (
      <Menu shadow="md" width={200}>
        <Menu.Target>
          <div className="log-out-Button">
            <div style={{ alignSelf: "center" }}>
              <img
                className="profile-icon"
                width={"40px"}
                height={"40px"}
                src={profileMale}
                alt={"user profile"}
              />
              <label className="profile-label"> {phoneNo}</label>
              {/* <IconMoodSmile className="profile-icon"></IconMoodSmile>{" "} */}
            </div>
          </div>
        </Menu.Target>
        <Menu.Dropdown>
          <Menu.Item
            onClick={(e: any) => {
              setLoading(true);
              logout(e);
            }}
          >
            <IconLogout></IconLogout>{" "}
            <label className="icon-log-out">{"Log Out"}</label>
          </Menu.Item>
        </Menu.Dropdown>
      </Menu>
    );
  };
  const logout = (e: any) => {
    e.preventDefault();
    storageService.clearAll();

    setTimeout(() => {
      setLogout(true);
    }, 1000);
  };

  const handleEditAppointment = (ele: any) => {
    setCurrentAppointment({ ...ele });
  };

  const getAppointmentListByPatient = (e: any) => {
    skip.current = 30;
    handleGetAllAppointments(1, 0, listStatus, "");
  };

  const formatDate = (dateString: any) => {
    const date = new Date(dateString);
    const month = ("0" + (date.getMonth() + 1)).slice(-2); // Add leading zero
    const day = ("0" + date.getDate()).slice(-2); // Add leading zero
    const year = date.getFullYear();
    return `${day}/${month}/${year}`;
  };

  const checkBookedFor = (id: number) => {
    if (id === 0) {
      return "Self";
    } else {
      return "Family";
    }
  };

  const checkPatientId = (pid: number, fid: number) => {
    if (pid != fid && fid != 0) {
      return fid;
    } else return pid;
  };

  const handleDateChange = (val: Date | null) => {
    if (val) {
      const localDate = new Date(
        val.getTime() - val.getTimezoneOffset() * 60000,
      );
      setNewDate(localDate);
    }
  };

  const closeModal = () => {
    setLabtestOpen(false);
  };
  const openNextModal = () => {
    setLabtestOpen(false);
    setNextModal(true);
  };
  const openPastModal = () => {
    setLabtestOpen(false);
    setPastModal(true);
  };
  const editModal = (e: any) => {
    setSelectedAppointment(e);
    setPatientID(e.appointment.patientID);
    setNewSelectedService(e.service.ID);
    setNewPincode(patientAddress.pincode);
    setNewAid(e.appointment.ID);
    setNewEmail(e.patient.email);
    setOpenEditModal(true);
    getAddress(e.appointment.patientID, e.appointment.addressId);
    getServiceEmail(e.service.ID);
  };
  const closeEditModal = () => {
    setOpenEditModal(false);
  };

  const tableHeaderStyle = {
    borderBottom: "1px solid #ccc",
    padding: "10px",
    textAlign: "left" as "left", // Specify 'left' as 'left' type
    fontSize: "12px",
    position: "sticky" as "sticky", // Specify 'sticky' as 'sticky' type
    top: 0,
    backgroundColor: "#f0f0f0",
    zIndex: 1,
  };

  const tableCellStyle = {
    borderBottom: "1px solid #eee",
    padding: "10px",
    fontSize: "12px",
  };

  const editButtonStyle = {
    padding: "5px 10px",
    cursor: "pointer",
    backgroundColor: "#ef7c01",
    color: "#fff",
    border: "none",
    borderRadius: "4px",
    fontSize: "12px",
  };

  const textFieldStyle = {
    height: "40px",
    fontSize: "12px",
  };

  const formControlStyle = {
    marginBottom: "10px",
  };

  const handleEmailChange = (value: string | null) => {
    setSelectedEmail(value || "");
  };

  return (
    <Container>
      {!logOut && (
        <Grid className="first-row-dashboard">
          <Grid.Col span={12}>
            <label className="dashboard-heading">
              <h1> Patients</h1>
            </label>
          </Grid.Col>
        </Grid>
      )}
      {!logOut && (
        <Grid className="search-bar-dashboard">
          <Grid.Col span={2}>
            <Select
              className="dropdown-dashboard"
              data={[
                { value: "1", label: "Id" },
                //   { value: "2", label: "Phone No" },
              ]}
              onChange={(val) => {
                let valstr = "";
                valstr = val as string;
                setSearchStatus(valstr);
              }}
              value={searchStatus}
            />
          </Grid.Col>
          {searchStatus === "2" && (
            <Grid.Col span={2}>
              <Select
                className="dropdown-dashboard"
                data={[
                  { value: "91", label: "India 91" },
                  { value: "97", label: "Dubai 97" },
                ]}
                onChange={(val) => {
                  let valstr = "";
                  valstr = val as string;
                  setCountryCode(valstr);
                }}
                value={countryCode}
              />
            </Grid.Col>
          )}

          <Grid.Col span={searchStatus === "1" ? 8 : 6}>
            <TextInput
              type="number"
              value={searchString}
              onChange={(val) => {
                let valstr = "";
                valstr = val.target.value as string;
                setSearchString(valstr);
                setSearchlist(valstr);
              }}
              placeholder={
                searchStatus === "1"
                  ? "Type ID to search"
                  : "Seach Phone Number"
              }
            />
          </Grid.Col>
          <LoadingOverlay visible={loading} overlayBlur={2} />
          <Grid.Col span={2} className="padding-zero">
            <Button
              className="search-button"
              onClick={() => {
                setLoading(true);
                searchPatient();
                getAppointmentListByPatient(searchString);
                setSearchlist(searchString);
              }}
            >
              SEARCH
            </Button>
          </Grid.Col>
        </Grid>
      )}
      {!logOut && (
        <Grid>
          <Grid.Col span={2} className="padding-zero">
            {logoutBtn()}
          </Grid.Col>
        </Grid>
      )}
      {logOut && (
        <Grid className="first-row-dashboard" style={{ textAlign: "center" }}>
          <Grid.Col span={12}>
            <label className="dashboard-heading">
              <h1> Logging Out..</h1>
            </label>
          </Grid.Col>
        </Grid>
      )}

      {appointmentSuccess && (
        <div style={NotificationStyles}>
          <Notification
            icon={<IconCheck size={18} />}
            color="teal"
            title="Appointment created."
            onClose={() => setAppointmentSuccess(false)}
          ></Notification>
        </div>
      )}

      {error !== "" && (
        <div style={NotificationStyles}>
          <Notification
            title="Cannot create appointment"
            icon={<IconX size={18} />}
            color="red"
            onClose={() => setError("")}
          >
            {error}
          </Notification>
        </div>
      )}

      <Modal
        size="lg"
        centered
        style={{ position: "fixed" }}
        opened={openLabtest}
        onClose={() => {
          closeModal();
        }}
      >
        <Button
          style={{
            marginLeft: "15px",
            height: "50px",
            width: "250px",
            backgroundColor: "#ef7c01",
            fontSize: "16px",
            marginRight: "50px",
          }}
          onClick={() => {
            openNextModal();
          }}
        >
          Create new appointment
        </Button>
        <Button
          style={{
            height: "50px",
            width: "250px",
            backgroundColor: "#ef7c01",
            fontSize: "16px",
          }}
          onClick={() => {
            openPastModal();
          }}
        >
          View past appointments
        </Button>
      </Modal>
      <Modal
        title={<b>Past appointments</b>}
        size="xl"
        centered
        onClose={() => {
          setPastModal(false);
        }}
        opened={pastModal}
      >
        <div style={{ maxHeight: "500px", overflowY: "auto" }}>
          <table
            style={{
              width: "100%",
              borderCollapse: "collapse",
              fontSize: "12px",
            }}
          >
            <thead>
              <tr style={{ borderBottom: "1px solid #ccc", textAlign: "left" }}>
                <th style={tableHeaderStyle}>Patient Id</th>
                <th style={tableHeaderStyle}>Appointment Id</th>
                <th style={tableHeaderStyle}>Service Type</th>
                <th style={tableHeaderStyle}>Appointment Date</th>
                <th style={tableHeaderStyle}>Booked For</th>
                <th style={tableHeaderStyle}>Actions</th>
              </tr>
            </thead>
            <tbody>
              {appointList.map((e: any, index: any) => (
                <tr
                  key={index}
                  style={{ borderBottom: "1px solid #eee", textAlign: "left" }}
                >
                  <td style={tableCellStyle}>
                    {checkPatientId(
                      e.appointment.patientID,
                      e.bookedForPatient.id,
                    )}
                  </td>
                  <td style={tableCellStyle}>{e.appointment.ID}</td>
                  <td style={tableCellStyle}>{e?.service?.type}</td>
                  <td style={tableCellStyle}>
                    {formatDate(e?.appointment?.appointmentDate)}
                  </td>
                  <td style={tableCellStyle}>
                    {checkBookedFor(e.bookedForPatient.id)}
                  </td>
                  <td style={tableCellStyle}>
                    {![2, 12, 13, 3, 11].includes(e.appointment.status) && (
                      <button
                        style={editButtonStyle}
                        onClick={() => editModal(e)}
                      >
                        Edit
                      </button>
                    )}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </Modal>

      <Modal
        opened={openEditModal}
        size="lg"
        onClose={() => {
          setOpenEditModal(false);
          setNewSelectedSlot("");
          setNewDate(undefined);
          setNewEmail(undefined);
          setNewSelectedSlot(undefined);
        }}
        title="Edit appointment"
        aria-labelledby="edit-appointment-modal-title"
        aria-describedby="edit-appointment-modal-description"
        style={{ position: "fixed" }}
      >
        <div style={{ borderRadius: "8px" }}>
          {selectedAppointment && (
            <div>
              <TextField
                label="Service Name"
                fullWidth
                margin="normal"
                defaultValue={selectedAppointment.service.name}
                variant="outlined"
                disabled
                InputProps={{ style: textFieldStyle }}
                InputLabelProps={{ style: textFieldStyle }}
                style={formControlStyle}
              />
              {addressFound && newAddress && (
                <TextField
                  label="Address"
                  fullWidth
                  margin="normal"
                  defaultValue={patientAddress}
                  variant="outlined"
                  disabled
                  InputProps={{ style: textFieldStyle }}
                  InputLabelProps={{ style: textFieldStyle }}
                  style={formControlStyle}
                />
              )}
              <TextField
                label="Client Code"
                fullWidth
                margin="normal"
                defaultValue={selectedAppointment.patient.clientCode}
                variant="outlined"
                disabled
                InputProps={{ style: textFieldStyle }}
                InputLabelProps={{ style: textFieldStyle }}
                style={formControlStyle}
              />
              <div style={formControlStyle}>
                <Select
                  value={selectedEmail}
                  label="Assigned to:"
                  data={serviceEmail.map((item) => ({
                    label: item.email,
                    value: item.email,
                  }))}
                  onChange={(value) =>
                    handleEmailChange(value as string | null)
                  }
                  clearable // Enables the clear button
                />
              </div>
              <TextField
                label="Appointment Date"
                fullWidth
                margin="normal"
                defaultValue={formatDate(
                  selectedAppointment.appointment.appointmentDate,
                )}
                variant="outlined"
                disabled
                InputProps={{ style: textFieldStyle }}
                InputLabelProps={{ style: textFieldStyle }}
                style={formControlStyle}
              />
              <TextField
                label="Time Slot"
                fullWidth
                margin="normal"
                defaultValue={TimeslotToString(
                  selectedAppointment.appointment.timeSlot,
                )}
                variant="outlined"
                disabled
                InputProps={{ style: textFieldStyle }}
                InputLabelProps={{ style: textFieldStyle }}
                style={formControlStyle}
              />
              <p style={{ fontSize: "10px", marginBottom: "4px" }}>
                New schedule
              </p>
              <DatePicker
                weekendDays={[]}
                placeholder="Choose a date"
                clearable={false}
                value={date}
                onChange={handleDateChange}
                label="Date"
                minDate={dayjs(new Date()).toDate()}
              />
              <Select
                value={newSelectedSlot === undefined ? "" : newSelectedSlot}
                label="Timeslot"
                placeholder={getNewPlaceholderText()}
                disabled={
                  loading ||
                  newDate === undefined ||
                  newEmail == undefined ||
                  (newSlots && newSlots.length === 0)
                }
                data={newSlots}
                onChange={handleNewSelectChange}
              />
              <Button
                color="#ef7c01"
                fullWidth
                disabled={
                  loading ||
                  newDate === undefined ||
                  newEmail == undefined ||
                  newSelectedSlot === undefined
                }
                onClick={() => {
                  setOpenEditModal(false);
                  rescheduleAppointment();
                  setLoading(true);
                }}
                style={{
                  marginTop: "20px",
                  backgroundColor:
                    loading ||
                    newDate === undefined ||
                    newEmail == undefined ||
                    newSelectedSlot === undefined
                      ? "lightgray"
                      : "#ef7c01",
                }}
              >
                Edit appointment
              </Button>
            </div>
          )}
        </div>
      </Modal>

      <Modal
        title={<b>Create an appointment</b>}
        size="lg"
        centered
        onClose={() => {
          setSelectedService(undefined);
          setDate(undefined);
          setSelectedSlot(undefined);
          setNextModal(false);
          setSelectedService(undefined);
          setSelectedEmail(undefined);
          setSelectedAddress("");
          setSelectedAddressId(null);
          setDate(undefined);
          setTimeSlotId(undefined);
          setSelectedSlot(undefined);
          setPincode("");
        }}
        opened={nextModal}
      >
        <label
          style={{ fontSize: "14px", fontWeight: "500" }}
          htmlFor="SearchDropdown"
        >
          Choose a service
        </label>
        <SearchDropdown
          options={services?.response}
          placeholder="Choose a service"
          styles={customStyles}
          onChange={(
            val: {
              value: number;
              label: string;
              maxDay: string;
              minDay: string;
              // Add other properties if needed
            } | null,
          ) => {
            const srv = services?.response?.filter((s: ServiceOption) => {
              console.log("S", s);
              return s.value === val?.value;
            });

            if (srv.length > 0) {
              setMinDay(srv.minDay);
              setMaxDay(srv.maxDay);
            }
            setSelectedService(val?.value);
            // setEmails([]);
            setSelectedEmail("");
            setDate(undefined);
            setSlots([]);
          }}
        />
        {emails && (
          <Select
            label="Assigned to:"
            value={selectedEmail}
            placeholder="Enter the email id"
            disabled={loading || selectedService === undefined}
            onChange={(val) => {
              setSelectedEmail(val as string);
              setDate(undefined);
              setSlots([]);
            }}
            data={emails as string[]}
          />
        )}
        {isAddress && (
          <div className="address-container">
            <div className="address-header">
              <p className="address-header-label">Choose an address</p>
              <a className="address-header-button" onClick={openAddAddress}>
                + Add Address
              </a>
            </div>

            <Select
              label=""
              value={selectedAddressId} // Value here and at data prop should be same
              placeholder="Choose an address"
              disabled={loading || selectedService === undefined}
              onChange={(val) => {
                // console.log("selected address is: ", val)
                setSelectedAddressId(Number(val));
                setSelectedAddress(val as String);
                const addressId = Number(val);
                const foundAddress = addresses.find(
                  (address: any) => address.id === addressId,
                );
                // console.log("pincode: ", foundAddress.pincode)
                setPincode(foundAddress.pincode);
              }}
              // data={addresses as string[]} // Previous code
              data={addresses.map(
                ({ id, formattedAddress, pincode }: Address) => ({
                  value: id,
                  label: formattedAddress,
                  pincode: pincode,
                }),
              )}
              onDropdownOpen={getAddresses}
            />
          </div>
        )}

        {isOpenAddAddress && (
          <Dialog open={isOpenAddAddress}>
            <div className="profile-address-top-heading">
              <h3>Address</h3>
              <Button
                className="profile-address-top-heading-back-button"
                onClick={() => {
                  setIsOpenAddAddress(false);
                }}
              >
                BACK
              </Button>
            </div>
            <Row className="row-address-diag">
              <Col>
                <Row>
                  <Col xs={12} sm={12} md={3} lg={4}>
                    <Autocomplete
                      disablePortal
                      id="combo-box-demo"
                      value={type}
                      options={addressTypes}
                      onChange={(e: any, v: any) => {
                        if (v) {
                          changeFields(v, "type");
                        }
                      }}
                      getOptionLabel={(option) => {
                        return option;
                      }}
                      renderInput={(params: any) => (
                        <TextField {...params} label="Address type" />
                      )}
                    />
                  </Col>

                  <Col xs={12} sm={12} md={3} lg={4}>
                    <TextField
                      style={{ width: "100%" }}
                      label="Full Name"
                      name="Full Name"
                      type="text"
                      // error={errorPinCode}
                      value={name || ""}
                      onChange={(value: any) => {
                        changeFields(value.target.value, "name");
                      }}
                      helperText={"Enter fullname"}
                    />
                  </Col>
                  <Col xs={12} sm={12} md={3} lg={4}>
                    <TextField
                      style={{ width: "100%" }}
                      label="Contact Number"
                      name="Contact Number"
                      type="text"
                      // error={errorPinCode}
                      value={phoneNo || ""}
                      onChange={(value: any) => {
                        var reg = RegExp("^[0-9]");

                        changeFields(value.target.value, "phone");
                      }}
                      helperText={"Enter a valid number"}
                    />
                  </Col>
                </Row>

                <Row style={{}}>
                  <Col xs={12} sm={12} md={3} lg={3}>
                    <TextField
                      style={{ width: "100%" }}
                      label="Pincode"
                      name="pincode"
                      type="text"
                      // error={errorPinCode}
                      value={pincode || ""}
                      onChange={(value: any) => {
                        var reg = RegExp("^[0-9]");

                        changeFields(value.target.value, value.target.name);
                      }}
                      helperText={"Fill Pincode"}
                    />
                  </Col>{" "}
                  <Col xs={12} sm={12} md={3} lg={3}>
                    <TextField
                      style={{ width: "100%" }}
                      label="District"
                      name="district"
                      type="text"
                      value={district}
                      onChange={(value: any) => {
                        // console.log("valuess", value.target.value)
                        changeFields(value.target.value, value.target.name);
                      }}
                      // lineDirection="center"
                    />
                  </Col>{" "}
                  <Col xs={12} sm={12} md={3} lg={3}>
                    <TextField
                      style={{ width: "100%" }}
                      label="State"
                      name="state"
                      type="text"
                      value={state || ""}
                      onChange={(value: any) => {
                        changeFields(value.target.value, value.target.name);
                      }}
                      // lineDirection="center"
                    />
                  </Col>{" "}
                  <Col xs={12} sm={12} md={3} lg={3}>
                    <TextField
                      style={{ width: "100%" }}
                      label="City"
                      name="city"
                      type="text"
                      value={city || ""}
                      onChange={(value: any) => {
                        changeFields(value.target.value, value.target.name);
                      }}
                      // lineDirection="center"
                    />
                  </Col>{" "}
                  <Col xs={12} sm={12} md={12} lg={12}>
                    <TextField
                      style={{ width: "100%", marginTop: "9px" }}
                      label="House No/Floor/Building "
                      name="line1"
                      type="text"
                      value={line1 || ""}
                      onChange={(value: any) => {
                        if (value.target.value.length > 60) {
                          value.target.value = value.target.value.slice(0, 60);
                        }
                        if (value.target.value.length < 61)
                          changeFields(value.target.value, value.target.name);
                      }}
                      // lineDirection="center"
                    />
                  </Col>
                  <Col xs={12} sm={6} md={8} lg={8}>
                    <TextField
                      style={{ width: "100%", marginTop: "9px" }}
                      label="Street/Area"
                      name="line2"
                      type="text"
                      value={line2 || ""}
                      onChange={(value: any) => {
                        if (value.target.value.length > 60) {
                          value.target.value = value.target.value.slice(0, 60);
                        }
                        if (value.target.value.length < 61)
                          changeFields(value.target.value, value.target.name);
                      }}

                      // lineDirection="center"
                    />
                  </Col>
                  <Col xs={12} sm={6} md={4} lg={4}>
                    <TextField
                      style={{ width: "100%", marginTop: "9px" }}
                      label="Landmark"
                      name="landmark"
                      type="text"
                      value={landmark || ""}
                      onChange={(value: any) => {
                        if (value.target.value.length > 30) {
                          value.target.value = value.target.value.slice(0, 30);
                        }
                        if (value.target.value.length < 31)
                          changeFields(value.target.value, value.target.name);
                      }}
                      // lineDirection="center"
                    />
                  </Col>
                </Row>
                {errorFlag && (
                  <Row>
                    <label style={{ color: "red" }}>Error in saving </label>
                  </Row>
                )}
                <Row className="btn-dialog-address">
                  <Button
                    className="btn-dialog-address-button"
                    disabled={
                      !district ||
                      pincode.length < 6 ||
                      pincode.length > 6 ||
                      !state ||
                      !city ||
                      !line1 ||
                      !line2 ||
                      !type ||
                      !name ||
                      phoneNo.length < 10
                    }
                    onClick={() => {
                      submit();
                      setIsOpenAddAddress(false);
                    }}
                  >
                    SAVE
                  </Button>
                </Row>
              </Col>
            </Row>
          </Dialog>
        )}

        <DatePicker
          weekendDays={[]}
          placeholder="Choose a date"
          clearable={false}
          value={date}
          disabled={
            loading ||
            selectedService === undefined ||
            selectedEmail == undefined
          }
          onChange={(val) => setDate(val as Date)}
          label="Date"
          minDate={dayjs(new Date()).toDate()}
        />
        <Select
          value={selectedSlot === undefined ? "" : selectedSlot}
          label="Timeslot"
          // placeholder={"Choose a timeslot"}
          placeholder={getPlaceholderText()}
          disabled={
            loading ||
            date === undefined ||
            selectedEmail == undefined ||
            (slots && slots.length === 0)
          }
          data={slots}
          // onChange={(val) => setSelectedSlot(val as string)}
          onChange={handleSelectChange} // To set slot time and slot id
        />
        <Button
          fullWidth
          disabled={
            loading ||
            selectedSlot === undefined ||
            date === undefined ||
            selectedService == undefined ||
            selectedEmail == undefined
          }
          mt="lg"
          style={{
            backgroundColor:
              loading ||
              selectedSlot === undefined ||
              date === undefined ||
              selectedService === undefined ||
              selectedEmail === undefined
                ? "lightgray"
                : "#ef7c01",
          }}
          type="submit"
          onClick={() => handleCreate()}
        >
          Create appointment
        </Button>
      </Modal>
    </Container>
  );
}

export default Dashboard;
